import axios from 'axios'

import { AWSService } from 'services/awsServices'
import { handleError } from 'services/handleApiResponseError'

import profileCRUD from './routes/profile'
import facilityCRUD from './routes/facility'
import groupCRUD from './routes/group'
import devicesCRUD from './routes/devices'
import alertsCRUD from './routes/alerts'
import helpSupportCRUD from './routes/helpSupport'

const _baseURL = process.env.REACT_APP_BASE_URL

class Client {
  token
  constructor(baseURL) {
    this.instanse = axios.create({
      baseURL,
      //timeout: 10000,
      headers: {
        'Content-Type': 'application/json; charset=utf-8; ',
      },
    })

    this.instanse.interceptors.request.use(async (config) => {
      if (!this.token) {
        config.headers = {
          ...config.headers,
        }
        return config
      }
      const refreshedToken = await this.checkToken()
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${refreshedToken || this.token}`,
      }
      return config
    })

    this.instanse.interceptors.response.use(
      (response) => response,
      (error) => {
        handleError(error)
        // eslint-disable-next-line no-undef
        return Promise.reject(error)
      }
    )

    this.profile = profileCRUD(this.instanse)
    this.facility = facilityCRUD(this.instanse)
    this.group = groupCRUD(this.instanse)
    this.devices = devicesCRUD(this.instanse)
    this.alerts = alertsCRUD(this.instanse)
    this.helpSupport = helpSupportCRUD(this.instanse)
  }

  get token() {
    return this._token
  }

  /**
   * @param {string} token
   */
  set token(token) {
    this._token = token
  }

  checkToken = async () => {
    try {
      let refreshedToken = this.token

      const isValidToken = AWSService.checkValidToken(refreshedToken)

      if (!isValidToken) {
        refreshedToken = await AWSService.getSession()
        this.token = refreshedToken
      }
      return refreshedToken
    } catch (error) {
      return this.token
    }
  }
}

const api = new Client(_baseURL)

export default api
